<label *ngIf="label" class="progress-bar__label">{{ label }}</label>
<div class="progress-bar" [class.reverse]="reverse">
  <span class="progress-bar__progress" [style]="style"></span>
</div>
<span *ngIf="showText" class="progress-bar__text">{{ showValue ? progressValue : (progress + '%') }}</span>
